const config = {
    build_number: '602615',
    build_timestamp: '2025-06-24T17:23:19.613Z',
    build_commit: '84d30139c13b4f669c3e5f6ca848561be5396cb7',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
